import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { AgGridModule } from 'ag-grid-angular';
import { TableStringRenderComponent } from './renderers/table-string-render/table-string-render.component';
import { TableCellActionsPanelComponent } from './renderers/table-cell-actions-panel/table-cell-actions-panel.component';
import { TableCellCheckboxRendererComponent } from './renderers/table-cell-checkbox-renderer/table-cell-checkbox-renderer.component';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { TableCellStatusRendererComponent } from './renderers/table-cell-status-renderer/table-cell-status-renderer.component';
import { TableCellEnumRendererComponent } from './renderers/table-cell-enum-renderer/table-cell-enum-renderer.component';
import { SelectModule } from '../select';

@NgModule({
  imports: [CommonModule, AgGridModule, CheckboxModule, SelectModule],
  declarations: [
    TableComponent,
    TableStringRenderComponent,
    TableCellActionsPanelComponent,
    TableCellCheckboxRendererComponent,
    TableCellStatusRendererComponent,
    TableCellEnumRendererComponent,
  ],
  exports: [TableComponent],
})
export class TableModule {}
